@if (link) {
  <a [routerLink]="link" class="button-component" role="button">
    {{ text }}
  </a>
} @else if (type === 'submit') {
  <button type="submit" class="button-component">
    {{ text }}
  </button>
} @else {
  <button type="button" class="button-component">
    {{ text }}
  </button>
}
